import { Head } from '@inertiajs/react'
import {
    Box,
    Container,
    Typography,
    ThemeProvider
} from '@mui/material'
import { ProfileCard } from '../../components'
import theme from '../../styles/theme'
import logo from '../../assets/rounded_logo.svg'

interface ProfileData {
    // Basic Info
    first_name: string;
    last_initial: string;
    profile_pic_url: string | null;
    short_intro: string;
    prospectId: string;

    // Employment
    occupation: string;
    employer: string;

    // Rental Preferences
    budget: string;
    bedrooms: string;
    bathrooms: string;
    desired_move_in: string;
    lease_length: string;
    rental_type?: string;
    tour_preference?: string;
    occupants: string;
    neighborhoods: string;
    additionalInfo: string;

    // Personal info
    age_range?: string;
    student?: boolean;
    undergraduate?: boolean;
    current_living_situation?: string;
    moving_reason?: string;

    // Screening info
    will_do_background_and_credit_check?: boolean;
    has_current_job_for_year?: boolean;
    has_year_long_rental?: boolean;
    income_verifiable?: boolean;

    // Pet and housing info
    housingVoucher: string;
    numDogs: string;
    numCats: string;
}

interface Props {
    profileData: ProfileData | null;
    error?: string;
}

export default function ViewProfile({ profileData, error }: Props) {
    if (error || !profileData) {
        return (
            <ThemeProvider theme={theme}>
                <Head title="Profile Not Found - HeyyProperty" />

                <Box sx={{
                    minHeight: '100vh',
                    bgcolor: 'grey.50',
                    py: 3
                }}>
                    <Container maxWidth="md">
                        {/* Logo */}
                        <Box sx={{ mb: 4 }}>
                            <img
                                src={logo}
                                alt="HeyyProperty"
                                style={{ height: '40px' }}
                            />
                        </Box>

                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minHeight: '60vh'
                        }}>
                            <Box sx={{ textAlign: 'center' }}>
                                <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
                                    Profile Not Found
                                </Typography>
                                <Typography variant="body1" color="grey.600">
                                    The profile you're looking for doesn't exist or has been removed.
                                </Typography>
                            </Box>
                        </Box>
                    </Container>
                </Box>
            </ThemeProvider>
        )
    }

    return (
        <ThemeProvider theme={theme}>
            <Head title={`${profileData.first_name} ${profileData.last_initial} Renter Profile`} />

            <Box sx={{
                minHeight: '100vh',
                bgcolor: 'grey.50',
                py: 3
            }}>
                <Container maxWidth="md">
                    {/* Logo */}
                    <Box sx={{ mb: 4 }}>
                        <img
                            src={logo}
                            alt="HeyyProperty"
                            style={{ height: '40px' }}
                        />
                    </Box>

                    {/* Profile Card */}
                    <ProfileCard profileData={profileData} />
                </Container>
            </Box>
        </ThemeProvider>
    )
}
